// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAgenciesRouteImport } from './routes/admin.agencies'
import { Route as AdminImageryRouteImport } from './routes/admin.imagery'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as PortalDownloadsRouteImport } from './routes/portal.downloads'
import { Route as PortalExplorerRouteImport } from './routes/portal.explorer'
import { Route as PortalHelpRouteImport } from './routes/portal.help'
import { Route as PortalOrdersRouteImport } from './routes/portal.orders'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAgenciesRoute = AdminAgenciesRouteImport.update({
            id: '/agencies',path: '/agencies',getParentRoute: () => AdminRoute
          })
const AdminImageryRoute = AdminImageryRouteImport.update({
            id: '/imagery',path: '/imagery',getParentRoute: () => AdminRoute
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminRoute
          })
const PortalIndexRoute = PortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalRoute
          })
const PortalDownloadsRoute = PortalDownloadsRouteImport.update({
            id: '/downloads',path: '/downloads',getParentRoute: () => PortalRoute
          })
const PortalExplorerRoute = PortalExplorerRouteImport.update({
            id: '/explorer',path: '/explorer',getParentRoute: () => PortalRoute
          })
const PortalHelpRoute = PortalHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => PortalRoute
          })
const PortalOrdersRoute = PortalOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => PortalRoute
          })





const AdminRouteChildren = {
  AdminAgenciesRoute: AdminAgenciesRoute,AdminImageryRoute: AdminImageryRoute,AdminOrdersRoute: AdminOrdersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const PortalRouteChildren = {
  PortalDownloadsRoute: PortalDownloadsRoute,PortalExplorerRoute: PortalExplorerRoute,PortalHelpRoute: PortalHelpRoute,PortalOrdersRoute: PortalOrdersRoute,PortalIndexRoute: PortalIndexRoute
}

const PortalRouteWithChildren = PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,LoginRoute: LoginRoute,PortalRoute: PortalRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)